import { theme } from 'antd';

import { CustomThemeToken } from '@/theme';

const { useToken } = theme;

const DessicantAirDryerWidget = ({
  width = 142,
  height = 174,
  color,
  ...rest
}: {
  width: number;
  height: number;
  color: string;
  [key: string]: unknown;
}) => {
  const { token } = useToken() as unknown as { token: CustomThemeToken };
  const currentColor = color ?? token.colorBgContainer;

  return (
    <svg width={width} height={height} viewBox="0 0 142 174" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M5 91.6223H3C1.89543 91.6223 1 90.7269 1 89.6223L1 81.6223C1 80.5177 1.89543 79.6223 3 79.6223H5L5 91.6223Z"
        fill={token.colorBorder}
      />
      <g filter="url(#filter0_ddd_24621_1878)">
        <path
          d="M67 19.5C67 22.9299 67 25 67 25C67 25 46.2611 25 36 25C25.7389 25 5.00004 25 5.00004 25C5.00004 25 5 22.9299 5 19.5C5 10.9396 18.8792 4 36 4C53.1208 4 67 10.9396 67 19.5Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <path
          d="M137 19.5C137 22.9299 137 25 137 25C137 25 116.261 25 106 25C95.7389 25 75 25 75 25C75 25 75 22.9299 75 19.5C75 10.9396 88.8792 4 106 4C123.121 4 137 10.9396 137 19.5Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <rect width="132" height="78" transform="translate(5 25)" fill={currentColor} stroke={currentColor} />
        <rect width="62" height="32" transform="translate(5 103)" fill={currentColor} stroke={currentColor} />
        <path
          d="M67 135.744C67 132.315 67 135 67 135C67 135 46.2611 135 36 135C25.7389 135 5 135 5 135C5 135 5 132.315 5 135.744C5 144.305 18.8792 151.244 36 151.244C53.1208 151.244 67 144.305 67 135.744Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <rect width="62" height="32" transform="translate(75 103)" fill={currentColor} />
        <path
          d="M137 135.744C137 132.315 137 135 137 135C137 135 116.261 135 106 135C95.7389 135 75 135 75 135C75 135 75 132.315 75 135.744C75 144.305 88.8792 151.244 106 151.244C123.121 151.244 137 144.305 137 135.744Z"
          fill={currentColor}
          stroke={currentColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M110 151.253C110 151.253 106 151.371 101.946 151.253L102 159.308H40V151.244C40 151.244 36.0005 151.371 32 151.244V165.26C32 166.356 32.8954 167.244 34 167.244H108C109.105 167.244 110 166.356 110 165.26V151.253Z"
          fill={currentColor}
          stroke={currentColor}
        />
      </g>
      <path
        d="M137 79.6223H139C140.105 79.6223 141 80.5177 141 81.6223V89.6223C141 90.7269 140.105 91.6223 139 91.6223H137V79.6223Z"
        fill={token.colorBorder}
      />
      <defs>
        <filter
          id="filter0_ddd_24621_1878"
          x="0"
          y="0"
          width="142"
          height="173.244"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24621_1878" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect2_dropShadow_24621_1878" />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_24621_1878" result="effect2_dropShadow_24621_1878" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0" />
          <feBlend mode="normal" in2="effect2_dropShadow_24621_1878" result="effect3_dropShadow_24621_1878" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_24621_1878" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};

export default DessicantAirDryerWidget;
